import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import { saveScript } from '../../script/api';
import { ScriptType } from '../../script/model';
import type { ScriptDto } from '../../script/script.dto';
import { MultiPromptTable } from '../../video/components/multi-prompt-table';
import { NavigateButton } from '../../video/components/navigate-button';

export const Scene = (props: {
  script: ScriptDto;
  index: number;
  isPending: boolean;
}) => {
  const { message } = App.useApp();
  const { index, script } = props;

  const save = useMutation({
    mutationFn: saveScript,
  });

  const handleSaveScript = async () => {
    await save.mutateAsync({
      type: ScriptType.Video,
      data: script,
      tags: null,
    });

    message.success('脚本保存成功');
  };

  return (
    <div
      key={script.id}
      className="rounded-xl border border-primary-200 bg-white p-6 transition-all duration-300 hover:border-primary-900/20"
    >
      <div className="flex flex-col gap-6 lg:items-start lg:justify-between">
        <div className="w-full flex-1 space-y-4">
          <div className="flex items-center space-x-2">
            <h5 className="text-lg font-bold">
              场景 {index + 1}
              {script.title && (
                <span className="ml-2 text-primary-500">· {script.title}</span>
              )}
            </h5>
            <div className="flex-auto"></div>
            <Button
              variant="filled"
              color="primary"
              onClick={() => {
                handleSaveScript();
              }}
            >
              保存脚本
            </Button>
            <NavigateButton
              enableAutoSave
              block={false}
              variant="solid"
              color="primary"
              script={props.script}
            ></NavigateButton>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {script.aspect_ratio && (
              <div className="rounded-lg bg-primary-50 p-3">
                <span className="text-sm text-primary-500">视频宽高比：</span>
                <span className="font-medium text-primary-800">
                  {script.aspect_ratio}
                </span>
              </div>
            )}

            {script.user_profile && (
              <div className="rounded-lg bg-primary-50 p-3">
                <span className="text-sm text-primary-500">人物形象：</span>
                <span className="font-medium text-primary-800">
                  {script.user_profile}
                </span>
              </div>
            )}

            {script.context && (
              <div className="rounded-lg bg-primary-50 p-3">
                <span className="text-sm text-primary-500">环境：</span>
                <span className="font-medium text-primary-800">
                  {script.context}
                </span>
              </div>
            )}

            {script.regional_features && (
              <div className="rounded-lg bg-primary-50 p-3">
                <span className="text-sm text-primary-500">区域背景：</span>
                <span className="font-medium text-primary-800">
                  {script.regional_features}
                </span>
              </div>
            )}
          </div>

          <div className="rounded-lg bg-primary-50 p-3">
            <div className="whitespace-pre-wrap font-medium text-primary-800">
              <MultiPromptTable
                segments={script.segments}
                extraPrompt={script.extra_prompt}
              ></MultiPromptTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
